import { formatMoney } from 'accounting'
import { DateTime } from 'luxon'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import type { CampaignQuoteTemplateModel } from '@models/types'

import { generateUrls } from '@hooks/useCampaignQuoteTemplate'

interface CampaignQuoteTemplateListItemProps {
  campaignQuoteTemplate: CampaignQuoteTemplateModel,
}

const formatDateText = (campaignQuoteTemplate: CampaignQuoteTemplateModel): string => {
  const { created_at, updated_at } = campaignQuoteTemplate

  const createdFormatted = created_at
    ? DateTime.fromISO(created_at)
      .toFormat("'Created' ccc dd LLL yyyy 'at' h:mm a")
    : undefined

  const updatedFormatted = updated_at
    ? DateTime.fromISO(updated_at)
      .toFormat("'Updated' ccc dd LLL yyyy 'at' h:mm a")
    : undefined

  if (createdFormatted && updatedFormatted){
    return `${createdFormatted} | ${updatedFormatted}`
  }
  if (createdFormatted){
    return createdFormatted
  }
  if (updatedFormatted){
    return updatedFormatted
  }
  return 'Not Set'
}

const CampaignQuoteTemplate = (props: CampaignQuoteTemplateListItemProps) => {
  const {
    campaignQuoteTemplate,
    campaignQuoteTemplate: {
      agency_id,
      title,
      total,
    },
  } = props

  const { editCampaignQuoteTemplateUrl } = generateUrls(campaignQuoteTemplate, {
    prefixRoute: `agencies/${agency_id}/manage`,
  })

  const secondaryTextDisplay = formatDateText(campaignQuoteTemplate)

  return (
    <DashboardModuleListItem
      href={editCampaignQuoteTemplateUrl}
      secondaryText={secondaryTextDisplay}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>{formatMoney(total)}</DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default CampaignQuoteTemplate
